/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentsObservabilityTracesBatchResponse {
    getFixupPrototypeFunction() { return AIAgentsObservabilityTracesBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AIAgentsObservabilityTracesBatchResponse>): AIAgentsObservabilityTracesBatchResponse {
        let obj = Object.assign(new AIAgentsObservabilityTracesBatchResponse(), model);
        AIAgentsObservabilityTracesBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentsObservabilityTracesBatchResponse>): AIAgentsObservabilityTracesBatchResponse {
        if (!model) return null;
        return AIAgentsObservabilityTracesBatchResponse.newInstance(<AIAgentsObservabilityTracesBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentsObservabilityTracesBatchResponse) {
        if (!obj) return;

        models.AIAgentsObservabilityTracesBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentsObservabilityTracesBatchResponse): boolean {
        Object.setPrototypeOf(obj, AIAgentsObservabilityTracesBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AIAgentTraceSpan.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AIAgentTraceSpan; };

}
